var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoalsEmergency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95983 12.5601V20.98C9.95983 22.0956 9.05547 23 7.93988 23V23C6.82429 23 5.91992 22.0956 5.91992 20.98V19.9959",
    stroke: "#0460ff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96094 1L9.96094 2.35785",
    stroke: "#0460ff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9219 12.022L18.9219 11.674C18.9219 6.72523 14.9101 2.71343 9.96126 2.71344C5.01246 2.71344 1.00066 6.72523 1.00066 11.674L1.00066 12.022L4.03903 10.6716C4.63426 10.4071 4.93188 10.2748 5.23008 10.2244C5.72749 10.1403 6.23876 10.215 6.69125 10.438C6.96253 10.5717 7.20981 10.7837 7.70437 11.2076L7.70438 11.2076C8.36083 11.7703 8.68906 12.0516 9.04147 12.1979C9.63033 12.4422 10.2922 12.4422 10.8811 12.1979C11.2335 12.0516 11.5617 11.7703 12.2182 11.2076L12.2182 11.2076C12.7127 10.7837 12.96 10.5717 13.2313 10.438C13.6838 10.215 14.195 10.1403 14.6924 10.2244C14.9906 10.2748 15.2883 10.4071 15.8835 10.6716L18.9219 12.022Z",
    stroke: "#282829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalsEmergency);
export default __webpack_public_path__ + "static/media/goals_emergency.36a37a75d645cc3a88d166c7a5e09686.svg";
export { ForwardRef as ReactComponent };